import { iots } from '@code-expert/prelude';
import type { GroupOption } from '/imports/api/hooks/client/courseSelect';
import { CourseUrl, GroupId, SemesterId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';
import { reviewSectionQuery } from '/imports/ui/pages/myGroups/details/navigation';
import { Page } from './pages';

export interface PathParams {
  semester: SemesterId;
  courseUrl: CourseUrl;
  groupId: GroupId;
}

export const getPathParams = ({ semester, courseUrl, _id: groupId }: GroupOption): PathParams => ({
  semester,
  courseUrl,
  groupId,
});

export const mygroupsSlug = 'mygroups';

const mygroups = lit(mygroupsSlug);
const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);
const groupId = type('groupId', GroupId);

export const myGroupsRoute = url(mygroups, end);

export const groupBaseRoute = url(mygroups, semester, courseUrl, groupId);
export const groupRoute = url(groupBaseRoute, end);

const pageSlug = (p: Page) => url(groupBaseRoute, lit(p));
export const detailsRoute = url(pageSlug('details'), end);

const reviewPresentationsSectionKeys = {
  today: null,
  upcoming: null,
  archive: null,
};

export type ReviewPresentationsSection = keyof typeof reviewPresentationsSectionKeys;

export const reviewPresentationsTabQuery = query(
  iots.exact(iots.partial({ section: iots.keyof(reviewPresentationsSectionKeys) })),
);

export const reviewPresentationsRoute = url(
  pageSlug('reviewPresentations'),
  reviewPresentationsTabQuery,
  end,
);

export const schedulePresentationsRoute = url(pageSlug('schedulePresentations'), end);
export const reviewExercisesRoute = url(pageSlug('reviewExercises'), reviewSectionQuery, end);
export const studentsRoute = url(pageSlug('students'), end);
export const participationRoute = url(pageSlug('participation'), end);

export const detailsLink = formatRoute(detailsRoute);
export const reviewPresentationsLink = formatRoute(reviewPresentationsRoute);
export const schedulePresentationsLink = formatRoute(schedulePresentationsRoute);
export const reviewExercisesLink = formatRoute(reviewExercisesRoute);
export const studentsLink = formatRoute(studentsRoute);
export const participationLink = formatRoute(participationRoute);

// Default page for a group
export const groupLink = reviewExercisesLink;

const page = type('page', Page);
export const myGroupsRouteWithPage = url(groupBaseRoute, page, end);
export const myGroupsPageLink = formatRoute(myGroupsRouteWithPage);
